/* Avalon scroll reveal ("fade and rise"). The element list and timings come from snippets/avalon-reveal.liquid
   (window.avalonReveal); the hidden/shown styles live there too. Each element is revealed once. */
(function () {
  var cfg = window.avalonReveal;
  var root = document.documentElement;
  if (!cfg) return;
  window.avalonRevealReady = true;

  if (!('IntersectionObserver' in window)) { root.classList.remove('avl-on'); return; }

  var STEP = 90;  // ms between siblings that appear together
  var MAX = 5;    // ...capped, so the last one never waits long

  function show(el, delay) {
    el.style.setProperty('--avl-d', delay + 'ms');
    el.classList.add('avl-in');
    // After the transition hand the element back to its own styles (hover effects etc.)
    setTimeout(function () {
      el.classList.add('avl-done');
      el.style.removeProperty('--avl-d');
    }, delay + cfg.ms + 150);
  }

  var io = new IntersectionObserver(function (entries) {
    var seen = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
    seen.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return Math.abs(ra.top - rb.top) > 8 ? ra.top - rb.top : ra.left - rb.left;
    });
    seen.forEach(function (el, i) {
      io.unobserve(el);
      show(el, Math.min(i, MAX) * STEP);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });

  function scan(scope) {
    (scope || document).querySelectorAll(cfg.sel).forEach(function (el) {
      if (el.avlSeen || el.classList.contains('avl-done') || el.closest('[data-avl="off"]')) return;
      el.avlSeen = true;
      io.observe(el);
    });
  }

  scan(document);
  // Theme Editor: sections re-render when edited, so pick up the new elements
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
